import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconVideos"><Path d="M4.75 3.75H19.25M11.5 13.25H12.25M11.5 13.25V13M11.5 13.25V13.5M10.75 10.75V15.75L14 13.25L10.75 10.75ZM5.75 20.25H18.25C19.9069 20.25 21.25 18.9069 21.25 17.25V9.25C21.25 7.59315 19.9069 6.25 18.25 6.25H5.75C4.09315 6.25 2.75 7.59315 2.75 9.25V17.25C2.75 18.9069 4.09315 20.25 5.75 20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconVideos;
